const t = {
  name: "BarChart",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 2C14.8977 2 14 2.89772 14 4V8L10 8C8.89772 8 8 8.89772 8 10L8 14H4C2.89772 14 2 14.8977 2 16L2 20C2 21.1023 2.89772 22 4 22L20 22C21.1023 22 22 21.1023 22 20L22 4C22 2.89772 21.1023 2 20 2L16 2ZM14 20H10L10 10H14V20ZM16 20L16 4H20L20 20L16 20ZM8 16V20H4L4 16H8Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as BarChart
};
